import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyTopBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-155">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-50 px-4 py-3 md:py-4 bg-cream-50/90 backdrop-blur-md border-b border-sage-100 shadow-sm" data-id="element-156">
          <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-157">
            <span className="font-serif font-medium text-warm-800 text-sm md:text-base tracking-tight" data-id="element-158">
              Protocolo Cuero Cabelludo en Calma
            </span>
            <button onClick={scrollToPricing} className="bg-sage-500 hover:bg-sage-600 text-white text-xs md:text-sm font-medium px-5 py-2.5 rounded-full transition-colors duration-300" data-id="element-159">
              Quiero mi protocolo
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}